import { addClass, isNullOrUndefined as isNOU, removeClass } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import { FormatPainterActions } from '../../editor-manager/plugin/format-painter-actions';
export class FormatPainter {
    constructor(parent) {
        this.isSticky = false;
        this.isActive = false;
        this.parent = parent;
        this.addEventListener();
        this.isDestroyed = false;
    }
    addEventListener() {
        this.parent.on(events.formatPainterClick, this.toolbarClick, this);
        this.parent.on(events.formatPainterDoubleClick, this.toolbarDoubleClick, this);
        this.parent.on(events.editAreaClick, this.editAreaClick, this);
        this.parent.on(events.keyDown, this.onKeyDown, this);
        this.parent.on(events.destroy, this.destroy, this);
        this.parent.on(events.bindOnEnd, this.bindOnEnd, this);
    }
    bindOnEnd() {
        if (!this.parent.formatter.editorManager.formatPainterObj) {
            this.parent.formatter.editorManager.formatPainterObj =
                new FormatPainterActions(this.parent.formatter.editorManager, this.parent.formatPainterSettings);
        }
    }
    toolbarClick(clickargs) {
        this.parent.focusIn();
        if (!this.isSticky) {
            this.isActive = true;
            this.actionHandler(clickargs, 'click');
        }
        else {
            // Handling the format painter double click toolbar esape action
            clickargs.args.action = 'escape';
            this.actionHandler(clickargs, 'keyBoard');
        }
        if (this.parent.quickToolbarModule && !isNOU(this.parent.quickToolbarSettings.text) &&
            this.parent.quickToolbarModule.textQTBar &&
            this.parent.element.ownerDocument.contains(this.parent.quickToolbarModule.textQTBar.element)) {
            this.parent.quickToolbarModule.textQTBar.hidePopup();
        }
    }
    toolbarDoubleClick(args) {
        this.isActive = true;
        this.isSticky = true;
        this.parent.focusIn();
        this.actionHandler(args, 'dbClick');
    }
    onKeyDown(event) {
        const originalEvent = event.args;
        if (!isNOU(originalEvent) && !isNOU(originalEvent.action) && (originalEvent.action === 'format-copy' || originalEvent.action === 'format-paste')
            || (originalEvent.action === 'escape' && (this.previousAction === 'format-copy' || this.previousAction === 'format-paste'))) {
            if ((originalEvent.action === 'format-copy' || originalEvent.action === 'format-paste')) {
                originalEvent.stopPropagation();
            }
            if (this.parent.userAgentData.getBrowser() === 'Firefox' || this.parent.userAgentData.getBrowser() === 'Safari') {
                originalEvent.preventDefault();
            }
            this.actionHandler(event, 'keyBoard');
        }
    }
    actionHandler(event, type) {
        let action;
        let isKeyboard = false;
        let originalEvent;
        let args;
        let item;
        switch (type) {
            case 'dbClick':
                args = event.args;
                item = args.item;
                originalEvent = event.args.originalEvent;
                action = 'format-copy';
                break;
            case 'keyBoard':
                args = null;
                originalEvent = event.args;
                isKeyboard = true;
                action = event.args.action;
                if (action === 'escape') {
                    this.isSticky = false;
                    this.isActive = false;
                }
                break;
            case 'click':
                args = event.args;
                item = args.item;
                originalEvent = event.args.originalEvent;
                action = 'format-copy';
                break;
            case 'docClick':
                originalEvent = event;
                action = 'format-paste';
                break;
        }
        if (isNOU(item)) {
            item = {
                command: 'FormatPainter',
                subCommand: 'FormatPainter'
            };
        }
        const actionBeginArgs = {
            requestType: 'FormatPainter', originalEvent: originalEvent, name: action, item: item
        };
        const value = {
            formatPainterAction: action
        };
        this.parent.formatter.process(this.parent, actionBeginArgs, originalEvent, value);
        if (!actionBeginArgs.cancel) {
            this.updateCursor(isKeyboard);
            const enable = type === 'docClick' || action === 'escape' ? false : true;
            this.updateToolbarBtn(enable);
        }
        this.previousAction = action;
    }
    updateCursor(isKeyboard) {
        if (!this.parent.inputElement.classList.contains('e-rte-cursor-brush') && !isKeyboard) {
            addClass([this.parent.inputElement], 'e-rte-cursor-brush');
        }
        else if (!this.isSticky) {
            removeClass([this.parent.inputElement], 'e-rte-cursor-brush');
        }
    }
    updateToolbarBtn(enable) {
        if (!isNOU(this.parent.element.querySelector('.e-rte-format-painter'))) {
            const toolbarBtn = this.parent.element.querySelector('.e-rte-format-painter').parentElement.parentElement;
            if (enable) {
                addClass([toolbarBtn], 'e-active');
            }
            else if (!this.isSticky) {
                removeClass([toolbarBtn], 'e-active');
            }
        }
    }
    editAreaClick(args) {
        if (this.isActive) {
            if (!this.isSticky) {
                this.isActive = false;
            }
            this.actionHandler(args, 'docClick');
            this.updateToolbarBtn(false);
        }
    }
    destroy() {
        if (this.isDestroyed) {
            return;
        }
        this.parent.off(events.formatPainterClick, this.toolbarClick);
        this.parent.off(events.editAreaClick, this.editAreaClick);
        this.parent.off(events.formatPainterDoubleClick, this.toolbarDoubleClick);
        this.parent.off(events.keyDown, this.onKeyDown);
        this.parent.off(events.destroy, this.destroy);
        this.parent.off(events.bindOnEnd, this.bindOnEnd);
        this.parent = null;
        this.isSticky = null;
        this.isActive = null;
        this.previousAction = null;
        this.isDestroyed = true;
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */
    getModuleName() {
        return 'formatPainter';
    }
}
